import type { SVGProps } from 'react';
const SvgTextRotationDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotation_down_svg__a)">
      <path
        fill="currentColor"
        d="M21 12v-1.5L10 5.75v2.1l2.2.9v5l-2.2.9v2.1L21 12Zm-7-2.62 5.02 1.87L14 13.12V9.38ZM6 19.75l3-3H7V4.25H5v12.5H3l3 3Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotation_down_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotationDown;
